import { useCallback } from "react";
import { Box } from "@mui/material";
import {
  DataGrid,
  DataGridProps,
  gridClasses,
  GridRowSpacingParams,
} from "@mui/x-data-grid";

export default function WorkflowFlatTable({ ...props }: DataGridProps) {
  const getRowSpacing = useCallback((params: GridRowSpacingParams) => {
    return {
      top: params.isFirstVisible ? 0 : 6,
      bottom: params.isLastVisible ? 0 : 6,
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: 268,
      }}
    >
      <DataGrid
        {...props}
        columnHeaderHeight={24}
        rowHeight={24}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        getRowSpacing={getRowSpacing}
        disableRowSelectionOnClick
        disableColumnMenu
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
        }}
        // modified to show all rows by default
        pageSizeOptions={[{ value: -1, label: "All" }]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: -1 },
          },
        }}
        hideFooterPagination={true}
        sx={{
          borderRadius: 1,
          border: "none",
          backgroundColor: "background.paper",
          [`& .${gridClasses.columnSeparator}`]: {
            [`&:not(.${gridClasses["columnSeparator--resizable"]})`]: {
              display: "none",
            },
          },
          [`& .${gridClasses.columnHeader}`]: {
            ...tableHeaderStyles,
            backgroundColor: "background.paper",
            borderBottom: "none !important",
          },
          [`& .${gridClasses.sortIcon}`]: {
            fontSize: "10px",
            color: "#0A0A22",
          },
          [`& .${gridClasses.footerContainer}`]: {
            borderTop: "none !important",
          },
          // remove focus outline
          [`& .${gridClasses.columnHeader}:focus`]: {
            outline: "none",
          },
          [`& .${gridClasses.columnHeader}:focus-within`]: {
            outline: "none",
          },
          [`& .${gridClasses.cell}:focus`]: {
            outline: "none",
          },
          [`& .${gridClasses.cell}:focus-within`]: {
            outline: "none",
          },
          "& .MuiDataGrid-row--borderBottom": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-cell": {
            border: "none",
          },
          "& .left-cell": {
            pl: 0.15,
          },
          "& .right-cell": {
            pr: 0.15,
          },
          [`& .${gridClasses.filler} > div`]: {
            borderTop: "none",
          },
        }}
      />
    </Box>
  );
}

export const tableTextStyles = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: "12px",
  fontWeight: 500,
  fontStyle: "normal",
  lineHeight: "1.33", // 16px / 12px → 1.33
};

const tableHeaderStyles = {
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: 1, // 10px / 10px → 1
  letterSpacing: "0.4px",
  textTransform: "uppercase",
};
